import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Firefox's \"funny\" css3 image scaling quirk",
  "description": "",
  "published": "2011-10-17T00:00:00.000Z",
  "redirect_from": ["/blog/firefoxs-funny-css3-image-scaling-quirk/swizec/2641"],
  "categories": "Cascading Style Sheets, CSS, HTML, JavaScript, Mozilla, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night as I was rewriting the CSS for `}<a parentName="p" {...{
        "href": "http://postme.me"
      }}>{`postme.me`}</a>{` from scratch and I was cursing and shouting obscenities under my breath and trying to find a way to punch all of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mozilla",
        "title": "Mozilla"
      }}>{`Mozilla`}</a>{` in the face over the internet ... I discovered something silly.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/Selection_044-300x122.png",
        "alt": null,
        "title": "A quirk"
      }}></img></p>
    <p>{`Scaling images is something every developer on the web has had to come to grips with. Maybe you were implementing an image gallery and wanted to display thumbnails, maybe you've reimplemented all the scaling algorithms several times.`}</p>
    <p>{`It's surprising how complex something as simple as making sure no dimension is beyond a certain size while maintaining aspect ratio can be. Which is exactly why I wanted to avoid the whole thing this time 'round and let the browser take care of it all.`}</p>
    {
      /*more*/
    }
    <p>{`Should be pretty simple with CSS right?`}</p>
    <p>{`Turns out it is, here's everything you have to do:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`img {
  max-width: 300px;
  max-height: 200px;
}
`}</code></pre>
    <p>{`Casting aside concerns such as load times and bandwidth for a moment. This is an elegant solution to a hairy problem. Browsers as it turns out do exactly the right thing - make sure neither dimension is too big and carefully adjusting the other dimension to maintain aspect ratio.`}</p>
    <p>{`But try putting that image into a flexbox div and strange things start happening in firefox.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/Selection_044.png",
        "alt": null,
        "title": "Flexbox and image scaling in FF"
      }}></img></p>
    <p>{`What's stranger still is that wrapping that same image into a vanilla div with zero styling not only fixes the image resizing issue, but also maintains centering and other flexbox properties you were originally going for.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/Selection_045.png",
        "alt": null,
        "title": "And then it works"
      }}></img></p>
    <p>{`You can check it out in action `}<a parentName="p" {...{
        "href": "http://swizec.com/code/firefox-scaling-quirk.html"
      }}>{`here`}</a>{`.`}</p>
    <p>{`Not sure exactly what's going on here, but I'm glad I managed to find a fix for one strange thing among many. Now I have a website full of very `}<em parentName="p">{`very`}</em>{` nonsemantic `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/HTML",
        "title": "HTML"
      }}>{`HTML`}</a>{` simply because of javascript's quirks.`}</p>
    <p>{`This brings up memories of times before I decided I don't care about IE support anymore ... granted, these features are far from standardized and it's therefore to be expected strangeness might appear. But Firefox is not where I expected such problems to crop up.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://coding.smashingmagazine.com/2011/09/19/css3-flexible-box-layout-explained/"
        }}>{`CSS3 Flexible Box Layout Explained`}</a>{` (coding.smashingmagazine.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.geek.com/articles/gadgets/firefox-for-tablets-tailors-browsing-experience-for-larger-android-displays-20110830/"
        }}>{`Firefox for Tablets tailors browsing experience for larger Android displays`}</a>{` (geek.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://codingpython.wordpress.com/2011/09/05/1661/"
        }}>{`10 jQuery Layout Tutorials`}</a>{` (codingpython.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=33f22781-c36e-4740-8b6a-4c2adb7d58c4",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      